import {Resource} from 'simpli-web-sdk'

export class MotoristaAlteracaoInfo extends Resource {
  idMotoristaFk: number = 0
  nomeResponsavelUltimaAlteracao: string | null = null
  dataUltimaModificacao: string | null = null

  get $id() {
    return this.idMotoristaFk
  }
  set $id(val) {
    this.idMotoristaFk = val
  }
}
